export const toPercent = (n: number): string => `${Math.round(n * 100)}%`;

export const toFixedDecimal =
  (dps = 2) =>
  (n: number) =>
    Intl.NumberFormat(undefined, {
      maximumFractionDigits: dps,
      minimumFractionDigits: dps,
    }).format(n);
